// @ts-nocheck

import { useState } from 'react';
import { connect } from 'react-redux';
import { yieldCallback } from '@zillow/yield-callback';
import LinkToggle from 'app/shared/modules/LinkToggle';
import HdpContentWrapper from 'app/shared/modules/hdp/HdpContentWrapper';
import ModelFloorplanItem from 'app/shared/modules/hdp/ModelFloorplanItem';
import TotalMonthlyPriceNotice from 'app/shared/modules/TotalMonthlyPrice/TotalMonthlyPriceNotice';
import TabGroup from 'app/shared/modules/TabGroup';
import TabItem from 'app/shared/modules/TabItem';
import { filterUtils_hasFilterChanged } from 'app/shared/utils/filterUtils';
import { shouldShowTotalMonthlyPriceBadge } from 'app/shared/utils/totalMonthlyPriceUtils';
import controller from './controller';
import { listingUtils_sortModelsByBeds } from 'app/shared/utils/listingUtils';
import { containerStyles, expandStyles, floorplanItemStyles, noticeWrapperStyles } from './MultiModelsGroup.styles';

interface MultiModelsGroupProps {
  onActionPopup: () => void;
  onClickOpenFdp: () => void;
  dispatch: any;
  filter: any;
  listing: any;
}

const MultiModelsGroup = (props: MultiModelsGroupProps) => {
  const [isTruncated, setIsTruncated] = useState(true);
  const { listing, filter, onActionPopup = () => {}, onClickOpenFdp = () => {} } = props;
  const isDefaultFilter = !filterUtils_hasFilterChanged(filter);
  const sortedFloorplans = listingUtils_sortModelsByBeds(listing.floorplans);
  const tabs = controller.getTabs({ floorplans: sortedFloorplans, filter, isDefaultFilter });

  const handleViewMoreClick = yieldCallback(() => {
    setIsTruncated(!isTruncated);
  });

  return (
    <div className="MultiModelsGroup">
      <HdpContentWrapper active fullContent header="Apartment floor plans" headerHtmlTag="h2">
        {shouldShowTotalMonthlyPriceBadge(listing) && (
          <div className={noticeWrapperStyles}>
            <TotalMonthlyPriceNotice listing={listing} />
          </div>
        )}
        <div className={containerStyles}>
          <TabGroup>
            {tabs.map((tab) => {
              const { floorplans, title } = tab;
              const renderedFloorplans = isTruncated ? floorplans.slice(0, 4) : floorplans.slice(0);

              return (
                <TabItem tabTitle={title} key={title}>
                  {renderedFloorplans.map((floorplan, i) => {
                    const { modelId } = floorplan;

                    return (
                      <div className={floorplanItemStyles} key={`${'ModelFloorplanItem-' + modelId + i}`}>
                        <ModelFloorplanItem
                          floorplan={floorplan}
                          listing={listing}
                          onActionPopup={onActionPopup}
                          onClickOpenFdp={onClickOpenFdp}
                        />
                      </div>
                    );
                  })}
                  {floorplans.length > 4 && (
                    <div className={expandStyles}>
                      <LinkToggle onClick={handleViewMoreClick}>
                        {isTruncated ? 'View more floor plans' : 'View fewer'}
                      </LinkToggle>
                    </div>
                  )}
                </TabItem>
              );
            })}
          </TabGroup>
        </div>
      </HdpContentWrapper>
    </div>
  );
};

export default connect()(MultiModelsGroup);
